import "./Navigation.css";
import Button from "../elements/Button";
import Dropdown from "react-bootstrap/Dropdown";
import HHLogo from "../../assets/Handl Health - Emblem - 3D Blue.png";
import Navbar from "react-bootstrap/Navbar";
import UserIcon from "../elements/UserIcon";
import down from "../../assets/icons/down.svg";
import largeRight from "../../assets/icons/largeRight.svg";
import navHomeLogo from "../../assets/navHomeLogo.svg";
import resourcesBlueDown from "../../assets/icons/resourcesBlueDown.svg";
import resourcesRight from "../../assets/icons/resourcesRight.svg";
import right from "../../assets/icons/right.svg";
import searchIcon from "../../assets/icons/searchIcon.svg";
import { Link } from "react-router-dom";
import { useLocation, useHistory } from "react-router-dom";
import React, {useState, useEffect, memo, useCallback, useRef} from "react";
import useAuthenticatedUser from "../../hooks/useAuthenticatedUser";
import debounce from "../../utils/debounce";


function MobileNavigation({user_data}) {

  const [openNavigation, setOpenNavigation] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const helpSectionOptions = [
    ...(user_data.id
      ? [
          {
            id: 1,
            text: "Need help?",
            action: () => history.push("/settings"),
          },
          {
            id: 2,
            text: "Logout",
            action: () => history.push("/signout"),
          },
        ]
      : [
          {
            id: 3,
            text: "Create an account",
            action: () => history.push("/signup"),
          },
          {
            id: 4,
            text: "Need help?",
            action: () => history.push("/contact"),
          },
        ]),
  ];
  
  const navbarClasses = "px-3 w-100 mobile-header bg-light-blue";

  const goToSearch = useCallback(() => {
        history.push({
            pathname: "/providers",
        });
  }, [history]);

  return (
    <>
      <Navbar
        fixed="top"
        expand="true"
        className={navbarClasses}
      >
        <a
          onClick={() => setOpenNavigation(!openNavigation)}
          className="nav-toggle"
        >
          {Array.from(Array(3)).map((el, idx) => (
            <span
              key={idx}
              className={`bar ${openNavigation ? "x" : ""}`}
            ></span>
          ))}
        </a>
      </Navbar>
      <div
        className={`flex-col updated-mobile-nav-container ${
          openNavigation ? "updated-mobile-nav-container__active" : ""
        }`}
      >
        <div className="flex-col">
          <div
            style={{
              display: "flex",
              gap: "65px",
              alignItems: "center",
              paddingBottom: "36px",
            }}
          >
            {user_data.id ? (
              <>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "32px" }}
                >
                  <UserIcon
                    fullName={user_data.attributes?.full_name || '--'}
                    style="large"
                  />
                  <div
                    onClick={() => history.push("/settings")}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <p
                      style={{ marginBottom: "3px" }}
                      className="text-small fw-400"
                    >
                      User
                    </p>
                    <p
                      style={{ marginBottom: "8px" }}
                      className="text-medium fw-500"
                    >
                      {user_data.attributes?.full_name || '--'}
                    </p>
                  </div>
                </div>

                <img src={right} alt="Right chevron icon" />
              </>
            ) : (
              <p
                style={{
                  fontSize: "32px",
                  paddingTop: "20px",
                  lineHeight: "48px",
                }}
                className="fw-700 default-blue"
              >
                Handl Health
              </p>
            )}
          </div>
            {location.pathname.endsWith('/providers') ? null :
                <React.Fragment>
                    <div
                        className=" find-an-estimate-container flex"
                        onClick={goToSearch}
                    >
                        <p
                            style={{ marginBottom: "0" }}
                            className="updated-mobile-nav-container__menu-options"
                        >
                            {user_data.id ? "Search Providers" : "Sign in"}
                        </p>
                        <img src={largeRight} alt="Large right icon" />
                    </div>
                    <div className="line" />
                </React.Fragment>
            }
          <div className="updated-mobile-nav-container__help-section">
            {helpSectionOptions.map((option) => (
              <p
                key={option.id}
                className="updated-mobile-nav__li-options"
                onClick={() => option.action()}
              >
                {option.text}
              </p>
            ))}
          </div>

          <img
            className="updated-mobile-nav-container__handl-logo"
            src={navHomeLogo}
            alt="Handl home logo"
          />
        </div>
      </div>
    </>
  );
}


function DesktopUserInformationMenu({user_data}) {

    const history = useHistory()

    const goSignOut = useCallback(()=>{
        history.push({
            pathname: "/signout",
        });
    }, [history])

    const settings_options = [
        ["Settings", "/settings"],
    ];

    return (
        <div className="userActions-navigation__dropdown-user-information">
            <div>
                <p style={{ marginBottom: "3px" }} className="text-small fw-400">
                    User
                </p>
                <p style={{ marginBottom: "8px" }} className="text-medium fw-500">
                    {user_data?.attributes?.full_name || '--'}
                </p>
            </div>
            <div>
                <p className="userActions-navigation__dropdown-user-information-label">
                    Account
                </p>
                <ul>
                    {settings_options.map((opt) => (
                        <Link key={opt[0]} to={opt[1]}>
                            <li>{opt[0]}</li>
                        </Link>
                    ))}
                </ul>
            </div>
            <Button
                label="Sign out"
                active={true}
                class="text-btn"
                onClick={goSignOut}
            />
        </div>
    );
};


function UserActions({user_data}) {

    const [show_user_info_dropdown, set_show_user_info_dropdown] = useState(false);
    const history = useHistory()
    const location = useLocation();

    const goToSignUp = useCallback(() => {
        history.push({
            pathname: "/signup",
        });
    }, [history]);

    const goToSignIn = useCallback(() => {
        history.push({
            pathname: "/signin",
        });
    }, [history]);

    const goToSearch = useCallback(() => {
        history.push({
            pathname: "/providers",
        });
    }, [history]);

    if (user_data.id) {
        return (
            <div className="navigation-bar__user-actions">
                {location.pathname.endsWith('/providers') ? null :
                    <div className="navigation-bar__user-actions-search">
                        <img
                            src={searchIcon}
                            alt="Search"
                            className="navigation-bar__user-actions-search-icon"
                            onClick={goToSearch}
                        />
                    </div>
                }
                <Dropdown
                    onToggle={(isOpen, event, metadata) => {
                        set_show_user_info_dropdown(isOpen);
                    }}
                >
                    <Dropdown.Toggle
                        className="navigation-bar__dropdown"
                        variant="link"
                        key="user-information"
                    >
                        <UserIcon
                            style="small"
                            active={show_user_info_dropdown}
                            fullName={user_data.attributes?.full_name}
                        />
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                        className="userActions-navigation__dropdown-user-information-menu"
                        show={show_user_info_dropdown}
                    >
                        <DesktopUserInformationMenu user_data={user_data}/>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        );
    } else {
        return (
            <div className="navigation-bar__user-actions">
                <Button
                    label="Create an account"
                    active={true}
                    class="text-btn"
                    className="navigation-bar__user-actions-btn"
                    onClick={(e) => goToSignUp()}
                />

                <Button
                    label="Sign in"
                    active={true}
                    class="outline-btn-blue"
                    className="navigation-bar__user-actions-btn"
                    onClick={(e) => goToSignIn()}
                />
            </div>
        );
    }
};


function DesktopNavigation({user_data}) {
    return (
        <div className="navigation-bar">
            <Link className="navigation-bar__link" key="press" to={{ pathname: "/" }}>
                <img src={HHLogo} alt="Handl Health logo" style={{ width: '40px', height: '40px' }} />
            </Link>
            <UserActions user_data={user_data}/>
        </div>
    )
}


function UserNavigation(props) {
    const [is_small_screen, set_is_small_screen] = useState(window.innerWidth <= 768);
    const is_small_screen_ref = useRef(is_small_screen)
    const {user_data} = useAuthenticatedUser()

    // This function determines if the page is on a small screen on load and anytime the screen resizes
    useEffect(() => {
    const fn_raw = ()=> {
        console.log("debounced resize check")
        const new_is_small_screen = window.innerWidth <= 768
        if (new_is_small_screen !== is_small_screen_ref.current) {
            is_small_screen_ref.current = new_is_small_screen
            set_is_small_screen(new_is_small_screen)
        }
    }
    const fn = debounce(fn_raw, 200)
    window.addEventListener("resize", fn);

    // returns a clean-up function that react will run itself on controller deletion
    return ()=>{
        window.removeEventListener("resize", fn)
    }
    }, [set_is_small_screen]);


    // const updateUserInformation = useCallback( (user_id)=> {
    //     if (!user_id) return;
    //     authApi.get("users/user_informations/" + user_id).then((response_data) => {
    //         const data = response_data.data.attributes;
    //         setUserZipcode(data.zip_code ? data.zip_code.zip_codes : "");
    //         setUserInformation({
    //             policyHolder: data?.policy_holder ? data.policy_holder : "",
    //             fullName: data?.full_name ? data.full_name : "",
    //         });
    //     })
    //         .catch(console.log);
    // }, [setUserZipcode, setUserInformation])


  return !is_small_screen ? (
    <DesktopNavigation user_data={user_data}/>
  ) : (
    <MobileNavigation user_data={user_data}/>
  );
}

const MemoizedUserNavigation = memo(UserNavigation, () => true);

export {
  MemoizedUserNavigation
}
